<template>
    <nav class="navbar navbar-light bg-light static-top">
        <div class="container">
            <a class="navbar-brand" href="/admin/dashboard">Dashboard</a>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'AdminNavigation',
    data: function() {
        return {
            
        }
    }
}
</script>

<!-- Custom Styles -->
<style>

</style>
